/** The `acts` area: the act sheet's rows (src/domain/act-sheet.ts and the
 *  surfaces that render it). */
export const acts = {
  /** The act words: a row and the pill that leads it read the same key. */
  'acts.verb.start': 'Start',
  'acts.verb.pause': 'Pause',
  /** The edges of the finishing lifecycle (docs/CLOSED_AXIS.md "Finishing"):
   *  one word per edge. */
  'acts.verb.done': 'Done',
  'acts.verb.readyForReview': 'Ready for review',
  'acts.verb.accept': 'Accept',
  'acts.verb.deny': 'Deny',
  'acts.verb.cancel': 'Cancel',
  'acts.verb.reopen': 'Reopen',
  'acts.verb.advance': 'Advance',
  /** The advance row's sub-line when the boundary refuses: the stage, and why. */
  'acts.advance.refused': '{stage} · {reason}',
  /** The advance row's sub-line: the stage, and what landing there applies. */
  'acts.advance.applies': '{stage} · applies {means}',
} as const;
